// Mock data for Global Trademark Federation website

export const mockData = {
  companyName: "Global Trademark Federation",
  tagline: "Protect Your Brand Legacy",
  heroDescription: "Professional trademark registration services across the USA. Secure your brand identity with our expert legal team.",
  
  // Pricing Plans
  pricingPlans: [
    {
      id: 1,
      name: "Essentials",
      price: "$45",
      filingFee: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Basic Search",
        "Electronic Filing",
        "Trademark Secured"
      ],
      note: "Govt. filing fee not included",
      recommended: false
    },
    {
      id: 2,
      name: "Enhanced",
      price: "$149",
      filingFee: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter"
      ],
      note: "Govt. filing fee not included",
      recommended: false
    },
    {
      id: 3,
      name: "Deluxe",
      price: "$299",
      filingFee: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager"
      ],
      note: "Govt. filing fee not included",
      recommended: true
    },
    {
      id: 4,
      name: "Platinum",
      price: "$349",
      filingFee: "+ Federal Filing Fee",
      features: [
        "Case Review",
        "Case Filing",
        "Direct Hit Search",
        "Trademark Alert",
        "Trademark Secured",
        "High Satisfaction Rate",
        "Refusal Risk Meter",
        "Trademark Monitoring",
        "Complete Documentation",
        "Digital File",
        "Dedicated Case Manager",
        "High Approval Rate",
        "Comprehensive Search Report",
        "High Priority Service",
        "Cease & Desist Letter"
      ],
      note: "Govt. filing fee not included",
      recommended: false
    }
  ],
  
  // Testimonials
  testimonials: [
    {
      id: 1,
      name: "Sarah Mitchell",
      company: "Mitchell & Co.",
      text: "Outstanding service! The team helped us secure our trademark quickly and efficiently. Highly professional and knowledgeable.",
      rating: 5
    },
    {
      id: 2,
      name: "James Rodriguez",
      company: "TechStart Solutions",
      text: "Global Trademark Federation made the entire trademark registration process seamless. Their expertise saved us time and money.",
      rating: 5
    },
    {
      id: 3,
      name: "Emily Chen",
      company: "Bloom Boutique",
      text: "Exceptional attention to detail and customer service. They guided us through every step of the process.",
      rating: 5
    },
    {
      id: 4,
      name: "Michael Thompson",
      company: "Thompson Industries",
      text: "Professional, reliable, and efficient. Our brand is now fully protected thanks to their expert team.",
      rating: 5
    },
    {
      id: 5,
      name: "Patricia Williams",
      company: "Creative Designs Studio",
      text: "The best investment we made for our business. Their trademark services are top-notch and affordable.",
      rating: 5
    }
  ],
  
  // Process Steps
  processSteps: [
    {
      id: 1,
      title: "Consultation",
      description: "Schedule a free consultation with our trademark experts to discuss your brand protection needs.",
      icon: "MessageSquare"
    },
    {
      id: 2,
      title: "Search & Analysis",
      description: "We conduct a comprehensive trademark search to ensure your mark is available for registration.",
      icon: "Search"
    },
    {
      id: 3,
      title: "Application Filing",
      description: "Our team prepares and files your trademark application with the USPTO following all legal requirements.",
      icon: "FileText"
    },
    {
      id: 4,
      title: "Monitoring & Support",
      description: "We monitor your application status and provide ongoing support until your trademark is secured.",
      icon: "Shield"
    }
  ],
  
  // Services
  // Service Categories for Mega Menu
  serviceCategories: [
    {
      id: 1,
      name: "Trademark Services",
      slug: "trademark-services",
      icon: "Award",
      services: [
        "register-trademark",
        "clearance-search",
        "trademark-ownership-transfer",
        "statement-of-use",
        "trademark-office-actions",
        "trademark-monitoring",
        "ttab-petition",
        "wipo-registration"
      ]
    },
    {
      id: 2,
      name: "Company Formation Services",
      slug: "company-formation-services",
      icon: "Building",
      services: [
        "llc-formation",
        "c-corporation",
        "s-corporation",
        "non-profit-formation"
      ]
    },
    {
      id: 3,
      name: "Copyright Services",
      slug: "copyright-services",
      icon: "BookOpen",
      services: [
        "register-copyright",
        "copyright-enforcement",
        "copyright-transfers",
        "copyright-legal-representation",
        "copyright-portfolio-management",
        "dmca-compliance"
      ]
    },
    {
      id: 4,
      name: "Patent Services",
      slug: "patent-services",
      icon: "Lightbulb",
      services: [
        "patent-search",
        "patent-office-actions",
        "patent-application",
        "patent-legal-representation"
      ]
    },
    {
      id: 5,
      name: "Legal Services",
      slug: "legal-services",
      icon: "Scale",
      services: [
        "business-immigration-law",
        "due-diligence",
        "it-commercial-law",
        "partnership-llp-services",
        "data-protection-privacy"
      ]
    },
    {
      id: 6,
      name: "Additional Corporate Services",
      slug: "additional-corporate-services",
      icon: "Briefcase",
      services: [
        "amazon-brand-registry",
        "bookkeeping-service",
        "business-formation",
        "certificate-good-standing",
        "company-dissolution",
        "company-name-change",
        "company-renewal",
        "issue-of-shares",
        "nominee-director-services",
        "tax-advisory-filing",
        "transfer-of-shares",
        "cfo-services"
      ]
    }
  ],

  services: [
    // TRADEMARK SERVICES (7)
    {
      id: 1,
      title: "Register Your Trademark",
      slug: "register-trademark",
      category: "Trademark Services",
      shortDesc: "Complete trademark registration services from search to final approval.",
      description: "Secure your brand identity with our comprehensive trademark registration services. We handle the entire process from initial search to final USPTO approval, ensuring your mark receives maximum protection.",
      benefits: [
        "Nationwide brand protection",
        "Legal ownership rights",
        "Exclusive use of your mark",
        "Enhanced brand value",
        "Legal recourse against infringement",
        "USPTO filing assistance"
      ],
      icon: "Award"
    },
    {
      id: 2,
      title: "Clearance Search Services",
      slug: "clearance-search",
      category: "Trademark Services",
      shortDesc: "Comprehensive trademark availability search before registration.",
      description: "Avoid costly rejections with our thorough trademark clearance search services. We analyze federal and state databases, common law marks, and domain names to ensure your mark is available.",
      benefits: [
        "Avoid application rejection",
        "Save time and money",
        "Identify potential conflicts",
        "Expert analysis report",
        "Strategic recommendations",
        "Comprehensive database search"
      ],
      icon: "Search"
    },
    {
      id: 3,
      title: "Trademark Ownership Transfers",
      slug: "trademark-ownership-transfer",
      category: "Trademark Services",
      shortDesc: "Seamless transfer of trademark ownership and assignment services.",
      description: "Transfer trademark ownership efficiently with our expert assignment services. We handle all documentation and USPTO filings to ensure smooth transfer of rights.",
      benefits: [
        "Complete documentation handling",
        "USPTO assignment filing",
        "Legal compliance assurance",
        "Transfer verification",
        "Title chain maintenance",
        "Expert legal guidance"
      ],
      icon: "RefreshCw"
    },
    {
      id: 4,
      title: "Submission of Statements of Use",
      slug: "statement-of-use",
      category: "Trademark Services",
      shortDesc: "File your Statement of Use to complete trademark registration.",
      description: "Complete your intent-to-use trademark application with our Statement of Use filing services. We ensure timely submission with proper evidence of commercial use.",
      benefits: [
        "Timely filing assistance",
        "Specimen review and preparation",
        "Extension requests if needed",
        "USPTO compliance",
        "Registration completion",
        "Deadline management"
      ],
      icon: "FileText"
    },
    {
      id: 5,
      title: "Support for Trademark Office Actions",
      slug: "trademark-office-actions",
      category: "Trademark Services",
      shortDesc: "Expert response to USPTO office actions and objections.",
      description: "Navigate trademark office actions successfully with our expert legal support. We craft compelling responses to overcome USPTO objections and refusals.",
      benefits: [
        "Expert legal analysis",
        "Strategic response preparation",
        "Increased approval chances",
        "Attorney representation",
        "Timely filing guarantee",
        "Comprehensive objection handling"
      ],
      icon: "MessageSquare"
    },
    {
      id: 6,
      title: "Active Monitoring for Trademark Infringement",
      slug: "trademark-monitoring",
      category: "Trademark Services",
      shortDesc: "24/7 monitoring to detect potential trademark infringement.",
      description: "Protect your brand with continuous trademark monitoring services. We track new filings, domain registrations, and marketplace listings to identify potential infringement.",
      benefits: [
        "Continuous surveillance",
        "Early infringement detection",
        "Alert notifications",
        "Competitor tracking",
        "Brand protection",
        "Legal action support"
      ],
      icon: "Eye"
    },
    {
      id: 7,
      title: "File TTAB Petition",
      slug: "ttab-petition",
      category: "Trademark Services",
      shortDesc: "Legal representation for Trademark Trial and Appeal Board proceedings.",
      description: "Navigate TTAB proceedings with experienced trademark attorneys. We handle oppositions, cancellations, and appeals before the Trademark Trial and Appeal Board.",
      benefits: [
        "Attorney representation",
        "Strategic case analysis",
        "Evidence preparation",
        "Legal brief drafting",
        "Hearing representation",
        "Appeal assistance"
      ],
      icon: "Gavel"
    },

    // COMPANY FORMATION SERVICES (4)
    {
      id: 8,
      title: "Limited Liability Company",
      slug: "llc-formation",
      category: "Company Formation Services",
      shortDesc: "Form your LLC with complete legal compliance and protection.",
      description: "Establish your Limited Liability Company with our comprehensive LLC formation services. We handle all paperwork, state filings, and compliance requirements.",
      benefits: [
        "Limited liability protection",
        "Tax flexibility",
        "Simple management structure",
        "Professional credibility",
        "Asset protection",
        "State filing assistance"
      ],
      icon: "Building"
    },
    {
      id: 9,
      title: "C Corporation",
      slug: "c-corporation",
      category: "Company Formation Services",
      shortDesc: "Form a C Corporation for maximum growth and investment potential.",
      description: "Establish your C Corporation with our expert formation services. Ideal for businesses seeking venture capital, going public, or having multiple shareholders.",
      benefits: [
        "Unlimited shareholders",
        "Stock issuance capability",
        "Perpetual existence",
        "Investment attraction",
        "Credibility with investors",
        "Complete documentation"
      ],
      icon: "TrendingUp"
    },
    {
      id: 10,
      title: "S Corporation",
      slug: "s-corporation",
      category: "Company Formation Services",
      shortDesc: "Form an S Corporation for pass-through taxation benefits.",
      description: "Create your S Corporation to enjoy corporate liability protection with pass-through taxation. We handle all IRS elections and state filings.",
      benefits: [
        "Pass-through taxation",
        "Limited liability protection",
        "Tax savings potential",
        "Credibility benefits",
        "IRS election assistance",
        "Compliance management"
      ],
      icon: "DollarSign"
    },
    {
      id: 11,
      title: "Non-Profit Organization",
      slug: "non-profit-formation",
      category: "Company Formation Services",
      shortDesc: "Establish your non-profit with 501(c)(3) tax-exempt status.",
      description: "Form your non-profit organization with our comprehensive services including 501(c)(3) application, bylaws, and state registration.",
      benefits: [
        "Tax-exempt status",
        "Grant eligibility",
        "Donation deductibility",
        "Legal compliance",
        "IRS application support",
        "Complete documentation"
      ],
      icon: "Heart"
    },

    // COPYRIGHT SERVICES (6)
    {
      id: 12,
      title: "Register Your Copyright",
      slug: "register-copyright",
      category: "Copyright Services",
      shortDesc: "Secure legal protection for your creative works.",
      description: "Protect your original works of authorship with comprehensive copyright registration. We handle literary, artistic, musical, and digital creations.",
      benefits: [
        "Legal proof of ownership",
        "Protection against plagiarism",
        "Ability to sue for infringement",
        "Statutory damages eligibility",
        "Public record of ownership",
        "International copyright protection"
      ],
      icon: "BookOpen"
    },
    {
      id: 13,
      title: "Assistance for Copyright Enforcement",
      slug: "copyright-enforcement",
      category: "Copyright Services",
      shortDesc: "Take action against copyright infringement with legal support.",
      description: "Enforce your copyright rights effectively with our legal assistance. We handle cease and desist letters, DMCA takedowns, and infringement litigation.",
      benefits: [
        "Infringement detection",
        "Cease and desist letters",
        "DMCA takedown notices",
        "Legal representation",
        "Settlement negotiation",
        "Litigation support"
      ],
      icon: "Shield"
    },
    {
      id: 14,
      title: "Copyright Transfers and Licensing",
      slug: "copyright-transfers",
      category: "Copyright Services",
      shortDesc: "Expert guidance for copyright transfers and licensing agreements.",
      description: "Navigate copyright transfers and licensing with professional legal support. We draft, review, and negotiate agreements to protect your interests.",
      benefits: [
        "Agreement drafting",
        "License negotiation",
        "Transfer documentation",
        "Rights protection",
        "Royalty structure",
        "Legal compliance"
      ],
      icon: "FileSignature"
    },
    {
      id: 15,
      title: "Legal Representation for Copyright",
      slug: "copyright-legal-representation",
      category: "Copyright Services",
      shortDesc: "Attorney representation for copyright disputes and litigation.",
      description: "Receive expert legal representation for copyright matters. Our attorneys handle disputes, litigation, and legal proceedings to protect your creative works.",
      benefits: [
        "Attorney representation",
        "Dispute resolution",
        "Court proceedings",
        "Settlement negotiation",
        "Evidence preparation",
        "Legal strategy"
      ],
      icon: "Scale"
    },
    {
      id: 16,
      title: "Management of Copyright Portfolio",
      slug: "copyright-portfolio-management",
      category: "Copyright Services",
      shortDesc: "Comprehensive management of your copyright portfolio.",
      description: "Manage your copyright portfolio efficiently with our expert services. We handle renewals, monitoring, licensing, and enforcement across all your creative works.",
      benefits: [
        "Portfolio organization",
        "Renewal management",
        "License tracking",
        "Revenue optimization",
        "Risk assessment",
        "Strategic planning"
      ],
      icon: "FolderOpen"
    },
    {
      id: 17,
      title: "Compliance with DMCA Act",
      slug: "dmca-compliance",
      category: "Copyright Services",
      shortDesc: "DMCA compliance and takedown notice services.",
      description: "Ensure DMCA compliance and protect your digital content. We handle takedown notices, counter-notices, and platform compliance procedures.",
      benefits: [
        "DMCA takedown filing",
        "Platform compliance",
        "Counter-notice response",
        "Safe harbor protection",
        "Digital content protection",
        "24/7 monitoring"
      ],
      icon: "Download"
    },

    // PATENT SERVICES (4)
    {
      id: 18,
      title: "Search for Existing Patent",
      slug: "patent-search",
      category: "Patent Services",
      shortDesc: "Comprehensive patent search to assess patentability.",
      description: "Conduct thorough patent searches to evaluate your invention's patentability. We search USPTO databases, international patents, and prior art.",
      benefits: [
        "Prior art search",
        "Patentability assessment",
        "Cost savings",
        "Strategic guidance",
        "Detailed report",
        "Expert analysis"
      ],
      icon: "Search"
    },
    {
      id: 19,
      title: "Support for Patent Office Actions",
      slug: "patent-office-actions",
      category: "Patent Services",
      shortDesc: "Expert response to USPTO patent office actions.",
      description: "Navigate patent office actions with experienced patent attorneys. We craft technical and legal responses to overcome USPTO objections.",
      benefits: [
        "Attorney representation",
        "Technical response",
        "Legal arguments",
        "Claim amendments",
        "Interview requests",
        "Approval optimization"
      ],
      icon: "MessageSquare"
    },
    {
      id: 20,
      title: "Application Submission for Patent",
      slug: "patent-application",
      category: "Patent Services",
      shortDesc: "Complete patent application preparation and filing.",
      description: "File your patent application with professional assistance. We prepare detailed specifications, claims, and drawings for utility, design, and provisional patents.",
      benefits: [
        "Application drafting",
        "Claims preparation",
        "Technical drawings",
        "USPTO filing",
        "Priority date establishment",
        "Comprehensive protection"
      ],
      icon: "FileText"
    },
    {
      id: 21,
      title: "Legal Representation for Patent Protection",
      slug: "patent-legal-representation",
      category: "Patent Services",
      shortDesc: "Attorney representation for patent disputes and enforcement.",
      description: "Protect your patents with experienced legal representation. We handle infringement litigation, licensing disputes, and patent defense.",
      benefits: [
        "Infringement litigation",
        "Patent defense",
        "Licensing negotiation",
        "Settlement strategy",
        "Trial representation",
        "Appeals handling"
      ],
      icon: "Scale"
    },

    // LEGAL SERVICES (5)
    {
      id: 22,
      title: "Business Immigration Law",
      slug: "business-immigration-law",
      category: "Legal Services",
      shortDesc: "Immigration legal services for businesses and employees.",
      description: "Navigate business immigration with expert legal guidance. We handle work visas, green cards, and compliance for international employees.",
      benefits: [
        "Visa application support",
        "Green card processing",
        "Compliance assistance",
        "Employee sponsorship",
        "Immigration strategy",
        "Legal representation"
      ],
      icon: "Globe"
    },
    {
      id: 23,
      title: "Due Diligence Process",
      slug: "due-diligence",
      category: "Legal Services",
      shortDesc: "Comprehensive due diligence for business transactions.",
      description: "Conduct thorough due diligence for mergers, acquisitions, and investments. We review legal, financial, and operational aspects.",
      benefits: [
        "Legal review",
        "Financial analysis",
        "Risk assessment",
        "Compliance verification",
        "Contract review",
        "Detailed reporting"
      ],
      icon: "CheckSquare"
    },
    {
      id: 24,
      title: "IT & Commercial Law",
      slug: "it-commercial-law",
      category: "Legal Services",
      shortDesc: "Legal services for IT and commercial business matters.",
      description: "Navigate IT and commercial legal matters with expert guidance. We handle technology contracts, licensing, and commercial agreements.",
      benefits: [
        "Technology contracts",
        "Software licensing",
        "Commercial agreements",
        "Vendor negotiations",
        "Compliance review",
        "Dispute resolution"
      ],
      icon: "Monitor"
    },
    {
      id: 25,
      title: "Legal Services on Partnerships & LLPs",
      slug: "partnership-llp-services",
      category: "Legal Services",
      shortDesc: "Comprehensive legal services for partnerships and LLPs.",
      description: "Establish and manage partnerships and LLPs with professional legal support. We handle formation, agreements, and compliance.",
      benefits: [
        "Partnership agreements",
        "LLP formation",
        "Dispute resolution",
        "Dissolution assistance",
        "Compliance management",
        "Legal documentation"
      ],
      icon: "Users"
    },
    {
      id: 26,
      title: "Data Protection & Privacy Law",
      slug: "data-protection-privacy",
      category: "Legal Services",
      shortDesc: "GDPR, CCPA, and data privacy compliance services.",
      description: "Ensure data protection compliance with expert legal guidance. We handle GDPR, CCPA, privacy policies, and data breach response.",
      benefits: [
        "GDPR compliance",
        "CCPA compliance",
        "Privacy policy drafting",
        "Data breach response",
        "Risk assessment",
        "Regulatory guidance"
      ],
      icon: "Lock"
    },

    // ADDITIONAL CORPORATE SERVICES (12)
    {
      id: 27,
      title: "Amazon Brand Registry",
      slug: "amazon-brand-registry",
      category: "Additional Corporate Services",
      shortDesc: "Enroll your brand in Amazon Brand Registry for enhanced protection.",
      description: "Protect and grow your brand on Amazon with Brand Registry enrollment. Access powerful tools for brand protection and enhanced content features.",
      benefits: [
        "Brand protection on Amazon",
        "Enhanced product listings",
        "Access to A+ Content",
        "Powerful search tools",
        "Proactive brand protection",
        "Counterfeit removal tools"
      ],
      icon: "ShoppingBag"
    },
    {
      id: 28,
      title: "Bookkeeping Service",
      slug: "bookkeeping-service",
      category: "Additional Corporate Services",
      shortDesc: "Professional bookkeeping services for your business.",
      description: "Maintain accurate financial records with our professional bookkeeping services. We handle accounts, reconciliation, and financial reporting.",
      benefits: [
        "Accurate record keeping",
        "Monthly reconciliation",
        "Financial reporting",
        "Tax preparation support",
        "Expense tracking",
        "Professional software"
      ],
      icon: "Calculator"
    },
    {
      id: 29,
      title: "Business Formation Services",
      slug: "business-formation",
      category: "Additional Corporate Services",
      shortDesc: "Complete business formation and entity setup services.",
      description: "Start your business right with comprehensive formation services. We handle entity selection, registration, and all necessary filings.",
      benefits: [
        "Entity selection guidance",
        "State registration",
        "EIN acquisition",
        "Operating agreements",
        "Corporate bylaws",
        "Complete documentation"
      ],
      icon: "Briefcase"
    },
    {
      id: 30,
      title: "Certificate of Good Standing",
      slug: "certificate-good-standing",
      category: "Additional Corporate Services",
      shortDesc: "Obtain certificate of good standing for your business.",
      description: "Secure your certificate of good standing to verify your business compliance. Required for loans, contracts, and business transactions.",
      benefits: [
        "State certification",
        "Compliance verification",
        "Quick processing",
        "Multiple state support",
        "Official documentation",
        "Expedited service"
      ],
      icon: "Award"
    },
    {
      id: 31,
      title: "Company Dissolution",
      slug: "company-dissolution",
      category: "Additional Corporate Services",
      shortDesc: "Properly dissolve your business entity with legal compliance.",
      description: "Close your business properly with our dissolution services. We handle all state filings, tax clearances, and final documentation.",
      benefits: [
        "State filing assistance",
        "Tax clearance support",
        "Asset distribution",
        "Liability protection",
        "Complete documentation",
        "Legal compliance"
      ],
      icon: "XCircle"
    },
    {
      id: 32,
      title: "Company Name Change",
      slug: "company-name-change",
      category: "Additional Corporate Services",
      shortDesc: "Change your company name with proper legal filings.",
      description: "Update your business name with our name change services. We handle amendments, state filings, and notification requirements.",
      benefits: [
        "Amendment filing",
        "State approval",
        "Updated documentation",
        "IRS notification",
        "Bank account updates",
        "Compliance maintenance"
      ],
      icon: "Edit"
    },
    {
      id: 33,
      title: "Company Renewal Services",
      slug: "company-renewal",
      category: "Additional Corporate Services",
      shortDesc: "Annual renewal and compliance filing services.",
      description: "Maintain your business good standing with renewal services. We handle annual reports, franchise taxes, and state compliance filings.",
      benefits: [
        "Annual report filing",
        "Franchise tax payment",
        "Compliance tracking",
        "Deadline management",
        "Multi-state support",
        "Good standing maintenance"
      ],
      icon: "RefreshCw"
    },
    {
      id: 34,
      title: "Issue of Shares",
      slug: "issue-of-shares",
      category: "Additional Corporate Services",
      shortDesc: "Professional share issuance and stock certificate services.",
      description: "Issue shares properly with our expert services. We handle stock certificates, capitalization tables, and regulatory compliance.",
      benefits: [
        "Stock certificate preparation",
        "Cap table management",
        "Securities compliance",
        "Documentation filing",
        "Shareholder records",
        "Legal compliance"
      ],
      icon: "PieChart"
    },
    {
      id: 35,
      title: "Nominee Director & Secretarial Services",
      slug: "nominee-director-services",
      category: "Additional Corporate Services",
      shortDesc: "Professional nominee director and company secretary services.",
      description: "Access professional nominee director and secretarial services for your company. Ensure compliance and governance requirements.",
      benefits: [
        "Professional nominee",
        "Corporate governance",
        "Compliance management",
        "Meeting minutes",
        "Record maintenance",
        "Regulatory filings"
      ],
      icon: "UserCheck"
    },
    {
      id: 36,
      title: "Tax Advisory & Filing",
      slug: "tax-advisory-filing",
      category: "Additional Corporate Services",
      shortDesc: "Comprehensive tax advisory and filing services.",
      description: "Navigate tax complexities with our expert advisory and filing services. We handle business taxes, planning, and IRS compliance.",
      benefits: [
        "Tax planning strategy",
        "Return preparation",
        "IRS compliance",
        "Deduction optimization",
        "Audit support",
        "Year-round advice"
      ],
      icon: "FileText"
    },
    {
      id: 37,
      title: "Transfer of Shares",
      slug: "transfer-of-shares",
      category: "Additional Corporate Services",
      shortDesc: "Facilitate share transfers with proper legal documentation.",
      description: "Execute share transfers properly with our professional services. We handle documentation, valuation, and regulatory compliance.",
      benefits: [
        "Transfer documentation",
        "Valuation assistance",
        "Regulatory compliance",
        "Stock certificate updates",
        "Cap table updates",
        "Legal filing"
      ],
      icon: "ArrowRightLeft"
    },
    {
      id: 38,
      title: "CFO Services",
      slug: "cfo-services",
      category: "Additional Corporate Services",
      shortDesc: "Fractional CFO services for strategic financial management.",
      description: "Access CFO-level expertise without full-time costs. We provide strategic financial planning, analysis, and management services.",
      benefits: [
        "Financial strategy",
        "Budget planning",
        "Cash flow management",
        "Financial reporting",
        "Investment analysis",
        "Board-level guidance"
      ],
      icon: "TrendingUp"
    },
    {
      id: 39,
      title: "WIPO Registration",
      slug: "wipo-registration",
      category: "Trademark Services",
      shortDesc: "International trademark registration through the World Intellectual Property Organization.",
      description: "Expand your brand protection globally with WIPO trademark registration under the Madrid Protocol. We guide you through the entire international filing process, helping you secure trademark rights in over 130 countries through a single application.",
      benefits: [
        "Global brand protection",
        "Single application for 130+ countries",
        "Cost-effective international filing",
        "Centralized trademark management",
        "Madrid Protocol expertise",
        "Streamlined renewal process"
      ],
      icon: "Globe"
    }
  ],
  
  // Why Choose Us
  whyChooseUs: [
    {
      id: 1,
      title: "Expert Legal Team",
      description: "Our experienced trademark attorneys have successfully registered thousands of trademarks across all industries.",
      icon: "Users"
    },
    {
      id: 2,
      title: "Fast Processing",
      description: "We expedite your trademark application to ensure quick filing and processing with the USPTO.",
      icon: "Zap"
    },
    {
      id: 3,
      title: "Affordable Pricing",
      description: "Transparent pricing with no hidden fees. We offer competitive rates for professional trademark services.",
      icon: "DollarSign"
    },
    {
      id: 4,
      title: "100% Satisfaction",
      description: "We are committed to your satisfaction with our comprehensive support throughout the registration process.",
      icon: "CheckCircle"
    }
  ],
  
  // FAQs
  faqs: [
    {
      id: 1,
      question: "What is a trademark?",
      answer: "A trademark is a unique symbol, word, phrase, design, or combination that identifies and distinguishes your goods or services from others in the marketplace."
    },
    {
      id: 2,
      question: "How long does trademark registration take?",
      answer: "The trademark registration process typically takes 8-12 months from filing to final registration, depending on the complexity of your application and USPTO processing times."
    },
    {
      id: 3,
      question: "Do I really need to register my trademark?",
      answer: "While not legally required, registering your trademark provides nationwide protection, legal presumption of ownership, and the exclusive right to use your mark in commerce."
    },
    {
      id: 4,
      question: "What's included in your trademark search?",
      answer: "Our comprehensive trademark search includes federal and state database searches, common law searches, and analysis of similar marks that could cause conflicts."
    },
    {
      id: 5,
      question: "What happens if my trademark is rejected?",
      answer: "If your trademark faces an office action or rejection, our experienced attorneys will work with you to respond appropriately and overcome any objections."
    },
    {
      id: 6,
      question: "How long does a trademark last?",
      answer: "A registered trademark can last indefinitely as long as you continue to use it in commerce and file the required maintenance documents with the USPTO."
    }
  ],
  
  // Contact Info
  contact: {
    email: "Info@globaltrademarkfederation.com",
    phone: "+1 (844) 632-0693",
    headOffice: "1333 New Hampshire Ave NW #200, Washington, DC 20036, United States",
    corporateBuilding: "300 S Grand Ave #10, Los Angeles, CA 90071, United States",
    address: "1333 New Hampshire Ave NW #200, Washington, DC 20036, United States",
    hours: "Monday - Friday: 9:00 AM - 6:00 PM EST"
  },
  
  // Country Codes for Contact Form
  countryCodes: [
    { code: "+1", country: "USA/Canada" },
    { code: "+44", country: "UK" },
    { code: "+91", country: "India" },
    { code: "+61", country: "Australia" },
    { code: "+81", country: "Japan" },
    { code: "+86", country: "China" },
    { code: "+33", country: "France" },
    { code: "+49", country: "Germany" },
    { code: "+39", country: "Italy" },
    { code: "+34", country: "Spain" },
    { code: "+7", country: "Russia" },
    { code: "+55", country: "Brazil" },
    { code: "+52", country: "Mexico" },
    { code: "+82", country: "South Korea" },
    { code: "+31", country: "Netherlands" },
    { code: "+46", country: "Sweden" },
    { code: "+47", country: "Norway" },
    { code: "+358", country: "Finland" },
    { code: "+41", country: "Switzerland" },
    { code: "+32", country: "Belgium" }
  ],
  
  // Hero Images
  heroImages: {
    home: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab",
    about: "https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d",
    services: "https://images.unsplash.com/photo-1431540015161-0bf868a2d407",
    contact: "https://images.unsplash.com/photo-1758519288480-1489c17b1519",
    lp: "https://images.unsplash.com/photo-1462899006636-339e08d1844e",
    default: "https://images.unsplash.com/photo-1444653614773-995cb1ef9efa"
  }
};
